import React from 'react'
import { get, pick } from 'lodash-es'
import { ErrorBoundary } from 'react-error-boundary'
import {
  TbViewProvider,
  useTbViewStore,
  useFetchRemoteData,
  useBeforeTransform,
  useProjectStore,
} from '@vt/hooks'
import { ModalsProvider } from '@mantine/modals'
import { DittoProvider } from '@ow/ditto-core'
import { upload, addWatermarkToImage } from '@vt/apis/lib-ex/v2/givrali'
import NavMenuOperate from '../container/container-render/NavMenuOperate'
import ContainerRender from '../container/container-render'
import DataOperateProvider from '../data-operate/DataOperateProvider'

const ViewContentRender = function ({
  showNavMenu = true,
  autoFetchData = true,
}) {
  const {
    // title,
    showRecycle,
    layouts = {},
  } = useTbViewStore((state) =>
    pick(state, ['layouts', 'showRecycle', 'title'])
  )

  const showLayouts = showRecycle ? layouts.recycleLayouts : layouts.layouts
  if (showLayouts && !showLayouts.elements.length) return null

  return (
    <DataOperateProvider>
      <div
        className="flex flex-col overflow-hidden flex-1"
        style={{ margin: '14px', gap: '14px' }}
      >
        <NavMenuOperate
          layouts={showNavMenu && showLayouts && showLayouts.navMenu}
        />
        <ErrorBoundary fallback={<div>layouts渲染错误</div>}>
          {get(showLayouts, 'elements', [])
            .filter((element) => !element.hidden)
            .map((element, index) => {
              return (
                <ContainerRender
                  key={`${element}-${index}`}
                  layouts={element}
                  // beforeTransform={beforeTransform}
                  autoFetchData={autoFetchData}
                />
              )
            })}
        </ErrorBoundary>
      </div>
    </DataOperateProvider>
  )
}

const TbViewbasic = function ({
  appId,
  tbId,
  vid,
  extendsStore,
  showNavMenu,
  children,
  autoFetchData,
}) {
  const fetchRemoteData = useFetchRemoteData()
  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )
  const beforeTransform =
    customCompsMap && customCompsMap.useBeforeTransform
      ? customCompsMap.useBeforeTransform
      : useBeforeTransform
  return (
    <DittoProvider
      appId={appId}
      tbId={tbId}
      onFetchRemoteData={fetchRemoteData}
      upload={upload}
      addWatermarkToImage={addWatermarkToImage}
      beforeTransform={beforeTransform}
    >
      <TbViewProvider
        appId={appId}
        tbId={tbId}
        vid={vid}
        extendsStore={extendsStore}
      >
        <ModalsProvider>{children}</ModalsProvider>
        <ViewContentRender
          showNavMenu={showNavMenu}
          autoFetchData={autoFetchData}
        />
      </TbViewProvider>
    </DittoProvider>
  )
}

export default TbViewbasic
